window.UserPreferencesManagerAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['UserPreferencesManagerServer']);

    self.getUserNavigationPreferences = async (brandId) => {
        const payload = {
            brand_id: brandId,
        };
        const response = await _protected.request('users/navigation_preferences', 'GET', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.updateUserNavigationPreferences = async (defaultHomePage) => {
        const payload = {
            default_home_page: defaultHomePage
        };
        const response = await _protected.request('users/navigation_preferences', 'PUT', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };
});
